import { useQuery } from '@tanstack/react-query';
import { SearchProduct } from '@winelivery-org/wl-client-sdk-js/dist/models/search';
import { getStoreProductById } from '@/services/search';

interface Params {
  hash: string;
  deliveryType?: string;
}

export function getFindProductByIdQueryOptions(
  id: string,
  filters: Params,
  initialData?: SearchProduct,
) {
  return {
    queryKey: ['product', id, filters],
    queryFn: () => getStoreProductById(id, filters),
    initialData,
  };
}

export default function useFindProductByIdQuery(
  id: string,
  filters: Params,
  initialData?: SearchProduct,
) {
  return useQuery(getFindProductByIdQueryOptions(id, filters, initialData));
}
